<template>
  <v-dialog max-width="720px" v-model="getModalCadastroLancamentoBancario">
    <v-card outlined :loading="$store.getters.getOverlay">
      <v-card-title>
        Cadastro de Lançamento Bancário
      </v-card-title>
      <v-form ref="form" class="px-3">
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 md6>
              <v-text-field outlined dense class="mr-2 ml-2" v-model="getLancamentoBancario.numero_documento" label="Número do Documento" :rules="rules.numero_documento"> </v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field outlined dense class="mr-2 ml-2" v-model="getLancamentoBancario.valor" label="Valor" v-mask="['#,##', '##,##', '###,###', '#.###,##', '##.###,##', '###.###,##']" :rules="rules.valor"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field outlined dense type="date" class="mr-2 ml-2" v-model="getLancamentoBancario.data_lancamento" label="Data" :rules="rules.data_lancamento"></v-text-field>
            </v-flex>
            <v-flex xs12 md6>
              <v-text-field outlined dense type="date" class="mr-2 ml-2" v-model="getLancamentoBancario.data_competencia" label="Competencia" :rules="rules.data_competencia"> </v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-text-field outlined dense class="mr-2 ml-2" v-model="getLancamentoBancario.historico" label="Histórico"></v-text-field>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                outlined
                dense
                class="mr-2 ml-2"
                :items="getBancos"
                v-model="getLancamentoBancario.banco_id"
                item-value="id"
                item-text="nome"
                label="Banco"
                append-outer-icon="control_point"
                @click:append-outer="setModalCadastroBanco(true)"
                :rules="rules.banco_id"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-autocomplete
                class="mr-2 ml-2"
                v-model="getLancamentoBancario.grupo_id"
                :items="getGruposFinanceiro"
                item-text="nome"
                item-value="id"
                label="Categoria"
                outlined
                dense
                append-outer-icon="control_point"
                @click:append-outer="cadastrarGrupoFinanceiro"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md12>
              <v-select
                :items="getPortadoresFinanceiro"
                v-model="getLancamentoBancario.portador_id"
                item-text="nome"
                item-value="id"
                label="Portador"
                outlined
                dense
                class="mr-2 ml-2"
                append-outer-icon="control_point"
                @click:append-outer="setModalListarPortadorFinanceiro(true)"
              ></v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-select outlined dense class="mr-2 ml-2" label="Tipo" :items="tiposLancamentos" v-model="getLancamentoBancario.tipo" :rules="rules.tipo"> </v-select>
            </v-flex>
            <v-flex xs12 md12>
              <v-autocomplete
                class="mr-2 ml-2"
                v-model="getLancamentoBancario.contato_id"
                :items="getContatos"
                item-text="nome"
                item-value="id"
                outlined
                dense
                append-outer-icon="control_point"
                @click:append-outer="cadastrarContato"
                label="Cliente/Fornecedor"
              ></v-autocomplete>
            </v-flex>
            <v-flex xs12 md12>
              <v-file-input label="Anexo" v-if="getShowInputAnexoLancamentoBancario" @change="selecionaAnexo" outlined dense class="mr-2 ml-2"></v-file-input>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-btn color="default" @click="setModalCadastroLancamentoBancario(false)" :loading="$store.getters.getOverlay" outlined>Voltar</v-btn>
          <v-btn color="primary" v-if="getLancamentoBancario.id && $helper.verificaPermissao('cadastrar-lancamento-financeiro')" @click="cadastrarLancamentoBancario" :loading="$store.getters.getOverlay" outlined>Novo</v-btn>
          <v-btn color="error" v-if="getLancamentoBancario.id" @click="setModalExcluirLancamentoBancario(true) && $helper.verificaPermissao('excluir-lancamento-financeiro')" :loading="$store.getters.getOverlay" outlined>Excluir</v-btn>
          <a v-if="getLancamentoBancario.anexo" :href="getLancamentoBancario.anexo" target="_blank"><v-btn color="default" class="mr-2 ml-2" :loading="$store.getters.getOverlay" outlined>Visualizar Anexo</v-btn></a>
          <v-spacer></v-spacer>
          <v-btn color="primary" v-if="getLancamentoBancario.id" :loading="$store.getters.getOverlay" outlined @click="imprimirComprovanteLancamentoBancario(getLancamentoBancario.id)">Comprovante</v-btn>
          <v-btn color="success" @click="salvar" v-if="!getLancamentoBancario.id" :loading="$store.getters.getOverlay" outlined>Salvar</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>

    <ModalExcluir />
    <ModalListarPortador />
    <ModalCadastroGrupo />
    <ModalCadastroContato />
    <ModalCadastroBanco />
  </v-dialog>
</template>

<script>
import ModalExcluir from "@/pages/financeiro/lancamentoBancario/ModalExcluir";
import ModalListarPortador from "@/pages/financeiro/portador/Listar";
import ModalCadastroGrupo from "@/pages/financeiro/grupo/ModalCadastro";
import ModalCadastroContato from "@/pages/contato/ModalCadastro";
import ModalCadastroBanco from "@/pages/banco/ModalCadastro";
import { mapGetters, mapActions } from "vuex";
export default {
  data() {
    return {
      tiposLancamentos: ["CRÉDITO", "DÉBITO"],
      rules: {
        numero_documento: [(v) => !!v || "Campo obrigatório"],
        data_lancamento: [(v) => !!v || "Campo obrigatório"],
        data_competencia: [(v) => !!v || "Campo obrigatório"],
        valor: [(v) => !!v || "Campo obrigatório"],
        banco_id: [(v) => !!v || "Campo obrigatório"],
        tipo: [(v) => !!v || "Campo obrigatório"],
      },
    };
  },
  watch: {
    getModalCadastroLancamentoBancario(){
      if(this.getModalCadastroLancamentoBancario){
        this.listarContatos({
          pagina: 1,
          id: "",
          nome: "",
          tipo: "",
          cpf_cnpj: "",
          cidade: "",
          telefone: "",
          limit: "",
        });
      }
    }
  },
  components: {
    ModalExcluir,
    ModalListarPortador,
    ModalCadastroGrupo,
    ModalCadastroContato,
    ModalCadastroBanco,
  },
  computed: {
    ...mapGetters(["getLancamentoBancario", "getModalCadastroLancamentoBancario", "getBancos", "getPortadoresFinanceiro", "getGruposFinanceiro", "getContatos", "getShowInputAnexoLancamentoBancario"]),
  },

  methods: {
    ...mapActions([
      "setModalCadastroLancamentoBancario",
      "setModalExcluirLancamentoBancario",
      "cadastrarLancamentoBancario",
      "salvarLancamentoBancario",
      "atualizarLancamentoBancario",
      "listarBancos",
      "listarGrupoFinanceiro",
      "listarPortadorFinanceiro",
      "setModalListarPortadorFinanceiro",
      "cadastrarGrupoFinanceiro",
      "listarContatos",
      "cadastrarContato",
      "setModalCadastroBanco",
      "imprimirComprovanteLancamentoBancario",
    ]),
    salvar() {
      if (this.$refs.form.validate() === false) {
        return;
      }

      if (!this.getLancamentoBancario.banco_id) {
        this.$store.commit("snackbarError", "Seleciona um banco.");
        return;
      }

      const form = new FormData();

      if (this.getLancamentoBancario.numero_documento) {
        form.append("numero_documento", this.getLancamentoBancario.numero_documento);
      }
      if (this.getLancamentoBancario.data_lancamento) {
        form.append("data_lancamento", this.getLancamentoBancario.data_lancamento);
      }
      if (this.getLancamentoBancario.data_competencia) {
        form.append("data_competencia", this.getLancamentoBancario.data_competencia);
      }
      if (this.getLancamentoBancario.historico) {
        form.append("historico", this.getLancamentoBancario.historico);
      }
      if (this.getLancamentoBancario.portador_id) {
        form.append("portador_id", this.getLancamentoBancario.portador_id);
      }
      if (this.getLancamentoBancario.grupo_id) {
        form.append("grupo_id", this.getLancamentoBancario.grupo_id);
      }
      if (this.getLancamentoBancario.banco_id) {
        form.append("banco_id", this.getLancamentoBancario.banco_id);
      }
      if (this.getLancamentoBancario.valor) {
        form.append("valor", this.getLancamentoBancario.valor);
      }
      if (this.getLancamentoBancario.tipo) {
        form.append("tipo", this.getLancamentoBancario.tipo);
      }
      if (this.getLancamentoBancario.contato_id) {
        form.append("contato_id", this.getLancamentoBancario.contato_id);
      }
      if (this.getLancamentoBancario.anexo) {
        form.append("anexo", this.getLancamentoBancario.anexo);
      }

      if (this.getLancamentoBancario.id) {
        form.append("_method", "PUT");
        form.append("id", this.getLancamentoBancario.id);
        this.atualizarLancamentoBancario(form);
      } else {
        this.salvarLancamentoBancario(form);
      }
    },
    selecionaAnexo(e) {
      this.getLancamentoBancario.anexo = e;
    },
  },

  created() {
    this.listarBancos();
    this.listarGrupoFinanceiro();
    this.listarPortadorFinanceiro();
    
  },
  beforeDestroy() {
    this.setModalCadastroLancamentoBancario(false);
  },
};
</script>
